import styled from 'styled-components';
import UIFlex from 'UIComponents/layout/UIFlex';
import { GREAT_WHITE } from 'HubStyleTokens/colors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const VerifyStepWrapper = styled.div.withConfig({
  displayName: "VerifyStep__VerifyStepWrapper",
  componentId: "pyg4id-0"
})(["border:1px solid ", ";border-bottom-width:0;text-align:left;&:last-child{border-bottom-width:1px;}"], GREAT_WHITE);
const VerifyStep = ({
  children,
  button
}) => /*#__PURE__*/_jsx(VerifyStepWrapper, {
  className: "p-all-6",
  children: /*#__PURE__*/_jsxs(UIFlex, {
    justify: "between",
    align: "center",
    children: [children, /*#__PURE__*/_jsx("div", {
      className: "m-left-4",
      children: button
    })]
  })
});
VerifyStep.displayName = 'VerifyStep';
export default VerifyStep;